import { ObjectEnum } from '@celito.clients/enums';

export const takingAssignmentObjectName = ObjectEnum.TRAINING_ASSIGNMENT;
export const taskObjectName = 'task__s';
export const courseObjectName = ObjectEnum.COURSE;
export const startTrainingObjectName = 'ta_start_training_action__a';
export const documentSignOffTag = 'ta_take_training';
export const trainerSignOffTag = 'ta_trainer_sign_off';
